import {useSelector} from "react-redux";
import React, {useState} from "react";

const DynamicOptionsComponent = () => {
    const matrix = useSelector(state => state.dynamicOptions.variantOptionsViewModel.optionMatrix || {})
    const selectedVariant = useSelector(state => state.dynamicOptions.variantOptionsViewModel.selectedVariant || {})
    const variants = useSelector(state => state.dynamicOptions.variantOptionsViewModel.variantData || [])
    const optionsDefaultValue = useSelector(state => state.dynamicOptions.variantOptionsViewModel.optionsDefaultValue || {})
    const colorKey = (selectedVariant.imageKey === undefined) ? "" : selectedVariant.imageKey; 
    const [colorName, setColorName] = useState(selectedVariant.data[colorKey.toLowerCase()] || "") 
    const [selectedOptions, setSelectedOptions] = useState(optionsDefaultValue || {})

    const clickOption = (option, value, currentLevel) => {
        let currentSelectedOptions = [...selectedOptions];
        const optionLength = matrix.options.length;

        // Find if the option is already selected and update or add it
        const existingOptionIndex = currentSelectedOptions.findIndex(s => s.key === option && s.level === currentLevel);
        if (existingOptionIndex !== -1) {
            currentSelectedOptions[existingOptionIndex] = { key: option, value, level: currentLevel };
        } else {
            currentSelectedOptions = currentSelectedOptions.filter(f => f.level < currentLevel);
            currentSelectedOptions.push({ key: option, value, level: currentLevel });
        }

        // Filter variants based on selected options
        let filteredVariants = variants;
        if (currentSelectedOptions.length === optionLength) {
            
            // Check variants
            for (const selectedOption of currentSelectedOptions) {
                filteredVariants = filteredVariants.filter(variant => 
                    variant.data[selectedOption.key.toLowerCase()] === selectedOption.value
                );
            }

            // Check if found match
            if (filteredVariants.length > 0) {
                setSelectedOptions(currentSelectedOptions);
                navigateTo(filteredVariants[0].url)
                return;
            }
        }

        // Remove selections below current level
        currentSelectedOptions = currentSelectedOptions.filter(f => f.level <= currentLevel);

        // Filter down to current selection level
        filteredVariants = variants;
        for (let a = 0; a <= currentLevel; a++) 
        {
            let selectedLevel = currentSelectedOptions[a];

            filteredVariants = filteredVariants.filter(variant => 
                variant.data[selectedLevel.key.toLowerCase()] === selectedLevel.value);
        }

        // Loop thru lower selection alternatives until finding a match
        if(currentLevel < optionLength) 
            for (let level = currentLevel; level < optionLength; level++) 
            {
                let name = matrix.options[level].name;

                // Add current selected option first in list to check
                let values = [selectedOptions[level], ...matrix.options[level].options];

                for(let valueIndex = 0; valueIndex < values.length; valueIndex++ )
                {
                    let value = values[valueIndex].value;

                    // Check if variant matches option
                    let newFilteredVariants = filteredVariants.filter(variant => 
                        variant.data[name.toLowerCase()] === value
                    );

                    // Check if found match
                    if(currentSelectedOptions.length <= level && newFilteredVariants.length > 0)
                    {
                        currentSelectedOptions.push({ key: name, value, level:level });
                        filteredVariants = newFilteredVariants;

                        // If we set a value for each option level navigate to variant
                        if (currentSelectedOptions.length == optionLength) {
                            setSelectedOptions(currentSelectedOptions);
                            navigateTo(newFilteredVariants[0].url)
                            return;

                        }
                       
                    }
                }

            }

        // Update selection
        setSelectedOptions(currentSelectedOptions);
    }

    const navigateTo = (url) => {
        location.replace(url); // Using replace url, as to not save every variant selected to history
    }

    const renderItem = (level, valueIndex, name, item) => {
        let value = item.value;

        // Check if this option value is has a variant with parent current option combination 
        let variantOptionExist = variants.filter(v => v.data[name.toLowerCase()] === value);
        for(let a = 1; a <= level; a++){
            const prevOptionVal = selectedOptions.find(s => s.level === level - a)
            variantOptionExist = variantOptionExist.filter(v => v.data[prevOptionVal.key.toLowerCase()] === prevOptionVal.value)
        }

        // Matching variant not found, don't display
        if(!(variantOptionExist.length > 0))
            return;

        // Handle styling depending on stock and if selected    
        let css = ""
        let isInStock = variantOptionExist.some(s => s.isInStock);
        if(selectedOptions.filter(f => f.key === name && f.value === value).length > 0){
            if(isInStock){
                css += "product-detail__dynamic--option--selected "
            }else{
                css += "product-detail__dynamic--option--selected-no-stock "
            }
        }
        else if(!isInStock){
            css += "product-detail__dynamic--option__out-of-stock "
        }
        
        // Image field
        if(item.variantImage !== undefined){
            return(
                <div key={valueIndex} className={"product-detail__dynamic--option__item " + css} onMouseOver={() => {setColorName(item.value)}} onMouseLeave={() => {setColorName(selectedVariant.data[colorKey.toLowerCase()])}} onClick={() => {clickOption(name, value, level)}}>
                    <img src={item.variantImage} />
                </div>
            )
        }

        // Normal field
        return (
            <div key={valueIndex} className={"product-detail__dynamic--option__item " + css } onClick={() => {clickOption(name, value, level)}}>
                {item.value}
            </div>
        )
    }
    
    return(
        <div className={"medium-12 columns"}>
            {matrix.options.map((option,i) => {
                if(i <= selectedOptions.length){
                    return(
                        <div key={i}>
                            {/* Option name */}
                            <div className={"product-detail__dynamic--option__option--name"}>
                                {option.name}
                                {option.name === colorKey ? <div className={"product-detail__dynamic--option__color--name"}>{colorName}</div> : ""}
                            </div>
                            {/* Option values */}
                            <div key={i} className={"product-detail__dynamic--option"}>
                                {option.options.map((item, ii) => {
                                    return (renderItem(i,ii,option.name,item)) 
                                })}
                            </div>
                        </div>
                    )
                }
            })}
        </div>
    )
}

export default DynamicOptionsComponent;